import { useTranslation } from 'react-i18next';
import { IoCTypeOptionsList } from '../../../utils/actors';
import { ExcludeSwitch } from '../../SearchPage/Filter/ExcludeSwitch';

import './Filter.scss';


export const IoCChooser = ({onChange, selected = [], excludeValue, onExcludeChange, isDisabled}) => {
  const { t } = useTranslation();

  const IoCTypeList = IoCTypeOptionsList(t);

  const handleSelect = () => {
    if (IoCTypeList.length !== selected.length) {
      onChange(IoCTypeList.map(ioc => ioc.value))
    } else {
      onChange([])
    }
  }

  return(
    <div className='chooser affiliations-search-filter'>
      <div className='affiliation-filter-controls-container'>
        <div className='control' onClick={() => handleSelect()}>{IoCTypeList.length === selected.length ? t('Deselect all') : t('Select all')}</div>
        <ExcludeSwitch
          id='iocs-switch'
          value={excludeValue}
          onChange={onExcludeChange}
          color='red'
          isDisabled={isDisabled}
        />
      </div>
      <ul>
        {IoCTypeList.map(ioc => {
          return(
            <li key={ioc.value}>
              <input 
                id={`ioc_${ioc.value}`}
                type='checkbox'
                checked={selected.includes(ioc.value)}
                onChange={() => {
                  if (selected.includes(ioc.value)) {
                    onChange(selected.filter(v => v !== ioc.value))
                  } else {
                    onChange([...selected, ioc.value])
                  }
                }}
              />
              <label htmlFor={`ioc_${ioc.value}`}>{ioc.label}</label>
            </li>
          )
        })}
        
      </ul>
    </div>
  )
}

